import React from "react";

import translations from "./quote-detail-translations";

// quote.date / quote.return_date are "YYYY-MM-DD" strings from the quote form.
const formatDay = (value, lang) =>
  new Intl.DateTimeFormat(lang, { weekday: "long", day: "numeric", month: "long", year: "numeric", timeZone: "UTC" })
    .format(new Date(value));

const formatTime = (hour, minute) => String(hour).padStart(2, "0") + ":" + String(minute).padStart(2, "0");

const QuoteDetail = (props) => {
  const { quote, lang } = props;
  const t = translations[lang];

  return (
    <section className="trip-card">
      <div className="trip-card-head">
        <h2>{t.summary}</h2>
        {quote.id !== undefined && <span className="trip-ref">{t.title} DEV-00{quote.id}</span>}
      </div>
      <ol className="trip-route">
        <li>
          <span>{t.startPlace}</span>
          <strong>{quote.address_depart}</strong>
        </li>
        <li>
          <span>{t.toPlace}</span>
          <strong>{quote.address_arrive}</strong>
        </li>
      </ol>
      <dl className="trip-facts">
        <div>
          <dt>{t.startDate}</dt>
          <dd>{formatDay(quote.date, lang)} · {formatTime(quote.hour, quote.minute)}</dd>
        </div>
        {quote.voyage === "return" && (
          <div>
            <dt>{t.toDate}</dt>
            <dd>{formatDay(quote.return_date, lang)} · {formatTime(quote.return_hour, quote.return_minute)}</dd>
          </div>
        )}
        <div>
          <dt>{t.passengers}</dt>
          <dd>{quote.passenger}</dd>
        </div>
        <div>
          <dt>{t.bagages}</dt>
          <dd>{quote.bagages}</dd>
        </div>
      </dl>
      {quote.price !== undefined && (
        <div className="trip-price">
          <span>{t.price}</span>
          <strong>{quote.price} €</strong>
        </div>
      )}
    </section>
  );
};

export default QuoteDetail;
